/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Ndamanagement_Lpspecificndas_Description4Inputs */

const en_coinvestments_ndamanagement_lpspecificndas_description4 = /** @type {(inputs: Coinvestments_Ndamanagement_Lpspecificndas_Description4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Override the global NDA for specific organisations.`)
};

/**
* | output |
* | --- |
* | "Override the global NDA for specific organisations." |
*
* @param {Coinvestments_Ndamanagement_Lpspecificndas_Description4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndamanagement_lpspecificndas_description4 = /** @type {((inputs?: Coinvestments_Ndamanagement_Lpspecificndas_Description4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndamanagement_Lpspecificndas_Description4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndamanagement_lpspecificndas_description4(inputs)
});
export { coinvestments_ndamanagement_lpspecificndas_description4 as "coInvestments_ndaManagement_lpSpecificNdas_description" }